module.exports = __webpack_public_path__ + "static/media/fix_cash50.62a1e7e9.png";